<section class="erfassung-page" [class.is-compact]="isCompact()" [class.has-bulk-selection]="selectionCount() > 0">
    <button type="button" class="back-link" (click)="goBack()">
        <mat-icon fontSet="material-icons-outlined">
            arrow_back
        </mat-icon>

        Zurück zur Übersicht
    </button>

    @if (loadError()) {
    <div class="load-error">
        <p>Inventur nicht gefunden.</p>

        <button type="button" (click)="goBack()">
            Zurück zur Übersicht
        </button>
    </div>
    } @else {

    <header class="page-header">
        @if (isLoading()) {
        <span class="skeleton-line skeleton-title"></span>
        <span class="skeleton-line skeleton-subtitle"></span>
        } @else {
        @if (detail(); as inventur) {
        <div class="header-row">
            <div>
                <h1>
                    {{ inventur.bezeichnung }} · Erfassung
                </h1>

                <p>
                    {{ inventur.filialeName }}
                    ·
                    {{ inventur.filialNummer }}
                    · ID:
                    {{ inventur.id }}
                </p>
            </div>

            <span class="status-pill" [ngClass]="getStatusClass(inventur.status)">
                {{ getStatusLabel(inventur.status) }}
            </span>
        </div>
        }
        }
    </header>

    <section class="kpi-grid" aria-label="Inventur Kennzahlen">
        @if (isLoading()) {
        @for (_ of skeletonKpiCards; track $index) {
        <div class="kpi-card kpi-card-skeleton">
            <span class="skeleton-line skeleton-label"></span>
            <span class="skeleton-line skeleton-number"></span>
        </div>
        }
        } @else {

        <div class="kpi-card">
            <span class="kpi-label">
                Noch zu bearbeitende Artikel
            </span>

            <strong [class.kpi-warning]="anzahlOffen() > 0" [class.kpi-success]="anzahlOffen() === 0">
                {{ anzahlOffen() }}
            </strong>
        </div>

        <div class="kpi-card">
            <span class="kpi-label">
                Gesamtwert Inventur
            </span>

            <strong>
                {{ formatBetrag(gesamtwert()) }} €
            </strong>
        </div>

        <div class="kpi-card">
            <span class="kpi-label">
                Fortschritt
            </span>

            <strong>
                {{ fortschritt() }} %
            </strong>
        </div>

        }
    </section>

    <section class="toolbar">
        <label class="search-field">
            <mat-icon fontSet="material-icons-outlined">
                search
            </mat-icon>

            <input #searchInput type="text" placeholder="Suche nach Artikelnummer oder Name…" [value]="searchTerm()"
                (input)="setSearchTerm(searchInput.value)" />

            @if (searchTerm()) {
            <button type="button" class="search-clear-button" aria-label="Suche zurücksetzen"
                (click)="setSearchTerm('')">
                <mat-icon fontSet="material-icons-outlined">
                    close
                </mat-icon>
            </button>
            }
        </label>

        <button type="button" class="add-article-button" (click)="openAddDialog()">
            <mat-icon fontSet="material-icons-outlined">
                add
            </mat-icon>

            <span>Artikel hinzufügen</span>
        </button>

        <label class="select-field select-field-narrow">
            <button type="button" class="select-trigger" (click)="toggleEinheitDropdown()">
                <span>
                    {{ selectedEinheitLabel() }}
                </span>

                <mat-icon class="select-arrow" fontSet="material-icons-outlined">
                    {{
                    isEinheitDropdownOpen()
                    ? 'expand_less'
                    : 'expand_more'
                    }}
                </mat-icon>
            </button>

            @if (isEinheitDropdownOpen()) {
            <div class="select-dropdown">
                @for (
                option of einheitOptionen();
                track option.value
                ) {
                <button type="button" class="select-option" [class.select-option-active]="
                        filterEinheit() === option.value
                    " (click)="selectEinheit(option.value)">
                    {{ option.label }}
                </button>
                }
            </div>
            }
        </label>

        <div class="toolbar-end">
            <label class="compact-toggle">
                <input type="checkbox" [checked]="isCompact()" (change)="toggleCompact()" />

                Kompaktmodus
            </label>

            <button type="button" class="undo-button" [disabled]="!canUndo()" (click)="undo()">
                <mat-icon fontSet="material-icons-outlined">
                    undo
                </mat-icon>

                Zurück
            </button>
        </div>
    </section>

    <section class="ansicht-filter">
        <button type="button" class="filter-tab" [class.filter-tab-active]="isAnsichtActive('ALLE')"
            (click)="setAnsichtFilter('ALLE')">
            Alle
        </button>

        <button type="button" class="filter-tab" [class.filter-tab-active]="isAnsichtActive('OFFEN')"
            (click)="setAnsichtFilter('OFFEN')">
            Offen
        </button>

        <button type="button" class="filter-tab" [class.filter-tab-active]="isAnsichtActive('ERFASST')"
            (click)="setAnsichtFilter('ERFASST')">
            Erfasst
        </button>
    </section>

    <section class="mobile-select-all">
        <input type="checkbox" [checked]="areAllFilteredSelected()" (change)="toggleSelectAllFiltered()"
            aria-label="Alle gefilterten Artikel auswählen" />

        <span class="mobile-select-all-label">
            Alle gefilterten Artikel auswählen
        </span>

        <span class="mobile-select-all-count">
            {{ selectionCount() }}/{{ selektierbareArtikel().length }}
        </span>
    </section>

    @if (selectionCount() > 0) {
    <section class="bulk-bar">
        <strong>
            {{ selectionCount() }} ausgewählt
        </strong>

        <button type="button" (click)="bulkSetNull()">
            Auf 0 setzen
        </button>

        <button type="button" class="bulk-clear" (click)="clearSelection()">
            <mat-icon fontSet="material-icons-outlined">
                close
            </mat-icon>

            Auswahl aufheben
        </button>
    </section>
    }

    <section class="artikel-table">
        <div class="table-scroll" [class.no-faktor]="isPosSession">
            <div class="table-header">
                <span class="select-cell">
                    <input type="checkbox" [checked]="areAllFilteredSelected()" (change)="toggleSelectAllFiltered()"
                        aria-label="Alle gefilterten Artikel auswählen" />
                </span>

                <button type="button" class="sort-button sort-button-wrap"
                    [class.sort-button-active]="isSortedBy('artikelnummer')" (click)="setSort('artikelnummer')">
                    <span class="sort-label">
                        Artikel&shy;nr.
                    </span>

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('artikelnummer') }}
                    </mat-icon>
                </button>

                <button type="button" class="sort-button" [class.sort-button-active]="isSortedBy('artikelname')"
                    (click)="setSort('artikelname')">
                    Artikel

                    <mat-icon fontSet="material-icons-outlined">
                        {{ getSortIcon('artikelname') }}
                    </mat-icon>
                </button>

                <span class="numeric">
                    VK €
                </span>

                <span class="numeric ist-head">
                    Menge
                </span>

                <span>
                    Einheit
                </span>

                <span class="numeric faktor-head">
                    Faktor
                </span>

                <span class="numeric">
                    Wert €
                </span>
            </div>

            <div #tableBody class="table-body">
                @if (isLoading()) {

                @for (_ of skeletonRows; track $index) {
                <div class="table-row table-row-skeleton">
                    @for (__ of skeletonCells; track $index) {
                    <span class="skeleton-line skeleton-cell"></span>
                    }
                </div>
                }

                } @else if (!gefilterteArtikel().length) {

                <div class="empty-state">
                    Keine Artikel für die aktuellen Filter.
                </div>

                } @else {

                @for (
                entry of gefilterteArtikel();
                track entry.id
                ) {
                <div class="table-row table-row-clickable" [attr.data-inventory-row-id]="entry.id" [class.row-active]="isNumpadOpenFor(entry)"
                    [class.row-new]="newlyAddedArticleId() === entry.id" [class.row-flash]="flashId() === entry.id"
                    [class.row-erfasst]="istErfasst(entry)" (click)="openNumpad(entry)">
                    <span class="select-cell" (click)="$event.stopPropagation()">
                        <input type="checkbox" [checked]="isSelected(entry.id)" [disabled]="!istSelektierbar(entry)"
                            (change)="toggleSelection(entry.id)" [attr.aria-label]="
                                'Artikel ' +
                                entry.artikelname +
                                ' auswählen'
                            " />
                    </span>

                    <span class="mono truncate" [title]="entry.artikelnummer">
                        {{ entry.artikelnummer }}
                    </span>

                    <span class="artikel-name" [title]="entry.artikelname">
                        <span class="artikel-name-text">
                            {{ entry.artikelname }}
                        </span>

                        @if (
                        newlyAddedArticleId() === entry.id
                        ) {
                        <span class="new-article-badge">
                            Neu
                        </span>
                        }
                    </span>

                    <span class="numeric vk-cell unit-dependent-value" [class.unit-meta-flash]="
                            unitMetaFlashId() === entry.id
                        ">
                        {{ formatBetrag(entry.verkaufspreis) }}
                    </span>

                    <span class="numeric ist-cell" (click)="$event.stopPropagation()">
                        <button type="button" class="ist-button" [class.ist-button-erfasst]="istErfasst(entry)"
                            (click)="openNumpad(entry)" title="Ist-Wert erfassen">
                            {{ getIstText(entry) }}

                            <small>
                                {{
                                getEinheitKuerzel(
                                entry.inventurEinheit
                                )
                                }}
                            </small>
                        </button>
                    </span>

                    <span class="einheit-cell unit-dependent-value" [class.unit-meta-flash]="
                            unitMetaFlashId() === entry.id
                        " (click)="$event.stopPropagation()">
                        <select (change)="
                                changeEinheit(
                                    entry,
                                    $any($event.target).value
                                )
                            " [attr.aria-label]="
                                'Inventur-Einheit für ' +
                                entry.artikelname
                            ">
                            @for (
                            option of entry.verfuegbareEinheiten;
                            track option.inventurEinheit
                            ) {
                            <option [value]="option.inventurEinheit" [selected]="
                                    option.inventurEinheit ===
                                    entry.inventurEinheit
                                " [disabled]="
                                    istEinheitBelegt(
                                        entry,
                                        option.inventurEinheit
                                    )
                                ">
                                {{ option.inventurEinheit }}
                            </option>
                            }
                        </select>
                    </span>

                    <span class="numeric muted faktor-cell unit-dependent-value" [class.unit-meta-flash]="
                            unitMetaFlashId() === entry.id
                        ">
                        {{ getFaktorText(entry) }}
                    </span>

                    <span class="numeric wert unit-dependent-value" [class.unit-meta-flash]="
                            unitMetaFlashId() === entry.id
                        ">
                        {{ getWertText(entry) }}
                    </span>
                </div>
                }

                }
            </div>
        </div>

        <footer class="table-footer">
            <span class="footer-item-inline">
                Gefiltert:
                <strong>
                    {{ gefilterteArtikel().length }}
                </strong>
            </span>

            <span class="footer-item-inline">
                Gesamt:
                <strong>
                    {{ anzahlArtikel() }}
                </strong>
            </span>

            <span class="footer-item-inline">
                Erfasst:
                <strong>
                    {{ anzahlErfasst() }}
                </strong>
            </span>

            <button type="button" class="finish-button" [disabled]="!canFinish()" (click)="openSummary()">
                Erfassung abschließen
            </button>
        </footer>
    </section>

    }
</section>

@if (activeArtikel(); as active) {
<aside class="numpad" role="dialog" aria-label="Ist-Bestand erfassen">
    <div class="numpad-inner">
        <div class="numpad-head">
            <span class="numpad-title">
                <span class="muted">
                    Erfassen:
                </span>

                <strong>
                    {{ active.artikelname }}
                </strong>

                @if (
                activeUnitOption();
                as unitOption
                ) {
                <span class="muted numpad-unit-meta">
                    · VK
                    {{ formatBetrag(unitOption.verkaufspreis) }}
                    €
                    · Faktor
                    {{
                    formatFaktor(
                    unitOption.umrechnungsfaktor
                    )
                    }}
                </span>
                }
            </span>

            <button type="button" class="numpad-close" (click)="closeNumpad()" aria-label="Numpad schließen">
                <mat-icon fontSet="material-icons-outlined">
                    close
                </mat-icon>
            </button>
        </div>

        <div class="numpad-units">
            @for (
            option of active.verfuegbareEinheiten;
            track option.inventurEinheit
            ) {
            <button type="button" class="numpad-unit-chip" [class.numpad-unit-chip-active]="
                    activeUnit() ===
                    option.inventurEinheit
                " [class.numpad-unit-chip-done]="
                    isUnitErfasst(
                        option.inventurEinheit
                    )
                " [attr.aria-pressed]="
                    activeUnit() ===
                    option.inventurEinheit
                " (click)="
                    selectUnit(
                        option.inventurEinheit
                    )
                ">
                <span class="numpad-unit-chip-name">
                    {{ option.inventurEinheit }}
                </span>

                @if (
                isUnitErfasst(
                option.inventurEinheit
                )
                ) {
                <span class="numpad-unit-chip-menge">
                    {{
                    unitMenge(
                    option.inventurEinheit
                    )
                    }}
                </span>
                }
            </button>
            }
        </div>

        <div class="numpad-display">
            <input #numpadInput type="text" inputmode="numeric" pattern="[0-9]*" [value]="inputValue()"
                [placeholder]="placeholderValue()" (input)="onNumpadInput(numpadInput)" (keydown.enter)="confirmInput()"
                aria-label="Ist-Bestand" />

            <span class="numpad-unit">
                {{ activeUnit() }}
            </span>
        </div>

        @if (liveWert() !== null) {
        <p class="numpad-live-total">
            {{ formatBetrag(liveWert()!) }}
            € Gesamtwert
        </p>
        }

        <div class="numpad-keys">
            @for (
            key of numpadKeys;
            track $index
            ) {
            @if (key === null) {

            <span class="numpad-spacer" aria-hidden="true"></span>

            } @else {

            <button type="button" class="numpad-key" [class.numpad-key-delete]="
                        key === numpadBackspace
                    " [attr.aria-label]="
                        key === numpadBackspace
                            ? 'Letzte Ziffer löschen'
                            : key
                    " (click)="pressNumpadKey(key)">
                {{ key }}
            </button>

            }
            }
        </div>

        <div class="numpad-steps">
            <button type="button" class="numpad-step" aria-label="Menge um 1 verringern" (click)="stepInput(-1)">
                <mat-icon fontSet="material-icons-outlined">
                    remove
                </mat-icon>

                <span>1</span>
            </button>

            <button type="button" class="numpad-step" aria-label="Menge um 1 erhöhen" (click)="stepInput(1)">
                <mat-icon fontSet="material-icons-outlined">
                    add
                </mat-icon>

                <span>1</span>
            </button>
        </div>

        <div class="numpad-actions">
            <button type="button" class="numpad-weitere" (click)="weitereEinheit()">
                <mat-icon fontSet="material-icons-outlined">
                    add
                </mat-icon>

                <span>
                    Weitere Einheit
                </span>
            </button>

            <button type="button" class="numpad-confirm" (click)="confirmInput()">
                Fertig · Nächster
            </button>
        </div>
    </div>
</aside>
}

@if (isAddOpen()) {
<div class="overlay" (click)="closeAddDialog()">
    <div class="overlay-panel add-dialog" role="dialog" aria-modal="true" aria-labelledby="inventur-add-title"
        (click)="$event.stopPropagation()">
        <header class="overlay-head">
            <h2 id="inventur-add-title">
                Artikel hinzufügen
            </h2>

            <button type="button" class="dialog-close" aria-label="Dialog schließen" (click)="closeAddDialog()">
                <mat-icon fontSet="material-icons-outlined">
                    close
                </mat-icon>
            </button>
        </header>

        <div class="add-body">
            <label class="add-search">
                <mat-icon fontSet="material-icons-outlined">
                    search
                </mat-icon>

                <input #addSearch type="text" placeholder="Artikelname oder Artikelnummer suchen…"
                    aria-label="Artikel im Katalog suchen" [value]="addQuery()"
                    (input)="setAddQuery(addSearch.value)" />
            </label>

            <div class="add-results">
                @if (
                katalogTreffer().length === 0
                ) {
                <p class="add-empty">
                    Kein Artikel gefunden.
                </p>
                } @else {

                @for (
                artikel of katalogTreffer();
                track artikel.artikelnummer
                ) {
                <button type="button" class="add-result" (click)="addKatalogArtikel(artikel)">
                    <span class="add-result-text">
                        <span class="add-result-name">
                            {{ artikel.artikelname }}
                        </span>

                        <span class="add-result-number">
                            {{ artikel.artikelnummer }}
                        </span>
                    </span>

                    <span class="add-result-price">
                        {{
                        formatBetrag(
                        artikel.verkaufspreis
                        )
                        }}
                        €
                    </span>
                </button>
                }

                }
            </div>
        </div>

        <footer class="overlay-footer">
            <button type="button" class="secondary" (click)="closeAddDialog()">
                Abbrechen
            </button>
        </footer>
    </div>
</div>
}

@if (isSummaryOpen()) {
<div class="overlay" role="dialog" aria-modal="true" aria-label="Zusammenfassung Inventur">
    <div class="overlay-panel">
        <header class="overlay-head">
            <h2>
                Zusammenfassung Inventur
            </h2>
        </header>

        <div class="summary-kpis">
            <div class="kpi-card">
                <span class="kpi-label">
                    Bearbeitete Artikel
                </span>

                <strong>
                    {{ anzahlErfasst() }}
                </strong>
            </div>

            <div class="kpi-card">
                <span class="kpi-label">
                    Offen
                </span>

                <strong [class.kpi-warning]="anzahlOffen() > 0" [class.kpi-success]="anzahlOffen() === 0">
                    {{ anzahlOffen() }}
                </strong>
            </div>

            <div class="kpi-card">
                <span class="kpi-label">
                    Gesamtwert
                </span>

                <strong>
                    {{ formatBetrag(gesamtwert()) }}
                    €
                </strong>
            </div>
        </div>

        <div class="summary-list" #summaryList (scroll)="
                onSummaryScroll(
                    $any($event.target)
                )
            ">
            @if (
            !erfassteArtikel().length
            ) {
            <p class="summary-empty">
                Noch kein Artikel erfasst.
            </p>
            } @else {

            <div class="summary-header">
                <span>
                    Artikel
                </span>

                <span class="numeric">
                    Ist
                </span>

                <span class="numeric">
                    Wert €
                </span>
            </div>

            @for (
            entry of erfassteArtikel();
            track entry.id
            ) {
            <div class="summary-row">
                <span class="truncate">
                    {{ entry.artikelname }}

                    <small>
                        {{ entry.artikelnummer }}
                    </small>
                </span>

                <span class="numeric">
                    {{ getIstText(entry) }}

                    {{
                    getEinheitKuerzel(
                    entry.inventurEinheit
                    )
                    }}
                </span>

                <span class="numeric">
                    {{
                    formatBetrag(
                    artikelWert(entry)
                    )
                    }}
                </span>
            </div>
            }

            }
        </div>

        @if (!summaryReviewed()) {
        <p class="summary-hint">
            Bitte scrolle durch die Liste,
            um die Erfassung final zu bestätigen.
        </p>
        }

        @if (anzahlOffen() > 0) {
        <p class="summary-hint">
            {{ anzahlOffen() }}
            Artikel sind noch nicht erfasst.
        </p>
        }

        @if (closeError()) {
        <p class="summary-error">
            Der Abschluss konnte nicht durchgeführt werden.
            Bitte versuche es erneut.
        </p>
        }

        <footer class="overlay-footer">
            <button type="button" class="secondary" [disabled]="isClosing()" (click)="closeSummary()">
                Zurück
            </button>

            <button type="button" class="primary" [disabled]="!canConfirmClose()" (click)="confirmClose()">
                {{
                isClosing()
                ? 'Wird abgeschlossen…'
                : 'Inventur bestätigen'
                }}
            </button>
        </footer>
    </div>
</div>
}